import React, { useEffect } from "react";
import "../assets/css/north.css";
import "../assets/css/home.css";
import "aos/dist/aos.css";
import AOS from "aos";
import { FaArrowRight } from "react-icons/fa";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import hero1 from "../assets/TIG Website Images/Home/Slide deck/newe.png";
import aboutImg from "../assets/about.jpg";
import reen1 from  '../assets/reen-1.jpeg'
import reen2 from  '../assets/reen-2.jpeg'
import reen3 from  '../assets/reen-3.jpeg'
import reen4 from  '../assets/reen-4.jpeg'
import reen5 from  '../assets/reen-5.jpeg'
import reen6 from  '../assets/reen-6.jpeg'
import ServicesCarousel from "./ServicesCarousel";

const projects = [
  { id: 1, img: reen1, title: "Retail Branding" },
  { id: 2, img: reen2, title: "Retail Branding" },
  { id: 3, img: reen3, title: "Retail Branding" },
  { id: 4, img: reen4, title: "Retail Branding" },
  { id: 5, img: reen5, title: "Retail Branding" },
  { id: 6, img: reen6, title: "Retail Branding" },
];

const services = [
  {
    id: 1,
    title: "Exhibition Stalls",
    desc: "We are redefining the world of advertising and visual communication with innovation, creativity, and precision.",
    icon: "fa fa-code"
  },
  {
    id: 2,
    title: "Designing",
    desc: "We are redefining the world of advertising and visual communication with innovation, creativity, and precision.",
    icon: "fa fa-code"
  },
  {
    id: 3,
    title: "Flange",
    desc: "We are redefining the world of advertising and visual communication with innovation, creativity, and precision.",
    icon: "fa fa-code"
  },
  {
    id: 4,
    title: "Sticker, Pamphlet",
    desc: "We are redefining the world of advertising and visual communication with innovation, creativity, and precision.",
    icon: "fa fa-code"
  }
];

const NewElite = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  

  return (
    <div>
      {/* Hero Section */}
      <div className="container-fluid p-0">
        <div className="hero-section" style={{ backgroundImage: `url(${hero1})` }}>
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100">
            <div className="col-lg-10 zoom-in-text">
                <p className="text-uppercase text-light m-0">
                GLOBAL CONNECTIONS
              </p>
              <h1 className="display-4 fw-bold text-light mb-4 animated slideInDown">
                New Elite International LLC (REEN)
              </h1>
            </div>
          </div>
        </div>
      </div>
 <ServicesCarousel />
      {/* About Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-start">
            <div className="col-lg-6 mb-4" data-aos="fade-up">
              <h5 className="text-muted mb-2">Who We Are</h5>
              <h2 className="fw-bold mb-3">
                Redefining advertising with <br /> innovation and creativity.
              </h2>
              <p>
                With years of expertise in designing, printing, exhibition stalls,
                UV printing, and signboard solutions, we provide complete branding
                and promotion services to elevate client visibility and market impact.
              </p>
              <p>
                Our commitment to excellence has positioned us as a leading provider
                in the advertising sector, delivering custom solutions to meet
                evolving business needs.
              </p>
              <button className="about-btn">About Us</button>
            </div>

            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div className="d-flex flex-column gap-3">
                <div className="d-flex p-3" data-aos="fade-up" data-aos-delay="200">
                  <div className="me-3 text-primary fs-5"><FaArrowRight /></div>
                  <div>
                    <h4>Trusted by Leading Brands</h4>
                    <p className="text-secondary">168 companies in 24 countries use our machines</p>
                  </div>
                </div>
                <div className="d-flex p-3" data-aos="fade-up" data-aos-delay="400">
                  <div className="me-3 text-primary fs-5"><FaArrowRight /></div>
                  <div>
                    <h4>End-to-End Creative Services</h4>
                    <p className="text-secondary">
                      From concept to execution – banners, 3D signage, ACP, UV prints, brochures, retail branding.
                    </p>
                  </div>
                </div>
                <div className="d-flex p-3" data-aos="fade-up" data-aos-delay="600">
                  <div className="me-3 text-primary fs-5"><FaArrowRight /></div>
                  <div>
                    <h4>Exhibition Expertise</h4>
                    <p className="text-secondary">
                      Customized exhibition stalls and event solutions for maximum audience engagement.
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="py-2 bg-white">
        <Container className="my-5 text-center" data-aos="fade-up">
          <h2 className="mb-3 fw-bold">Our Projects</h2>
          <p className="mb-5 fs-4">
            We deliver innovative and creative branding solutions across various industries.
          </p>
          <Row>
            {projects.map((project) => (
              <Col key={project.id} md={4} sm={6} className="mb-4">
                <div className="project-card">
                  <img src={project.img} alt={project.title} className="img-fluid" />
                  <div className="overlay">
                    {/* <h5>{project.title}</h5> */}
                    {/* <p>Creative branding solutions for your business</p> */}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

     
    </div>
  );
};

export default NewElite;
